import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

// import UserLogin from '@/components/pages/UserLogin.vue';
import PasswordReissue from '@/components/pages/PasswordReissue.vue';
import OnetimePasswordReissue from '@/components/pages/OnetimePasswordReissue.vue';
import CompletePasswordReissue from '@/components/pages/CompletePasswordReissue.vue';
// import UserRegister from '@/components/pages/UserRegister.vue';
// import ConfirmUserRegister from '@/components/pages/ConfirmUserRegister.vue';
import ConfirmUserAddress from '@/components/pages/ConfirmUserAddress.vue';
import CompleteUserRegister from '@/components/pages/CompleteUserRegister.vue';

import Top from '@/components/pages/Top.vue';
import Store from '@/components/pages/Store.vue';
import StoreGachaLineup from '@/components/pages/StoreGachaLineup.vue';
import StorePackDetail from '@/components/pages/StorePackDetail.vue';
import PackList from '@/components/pages/PackList.vue';
import PackDetail from '@/components/pages/PackDetail.vue';
import BuyPoint from '@/components/pages/BuyPoint.vue';
import ConfirmBuyPoint from '@/components/pages/ConfirmBuyPoint.vue';
import ConfirmCombini from '@/components/pages/ConfirmCombini.vue';
import BankTransferInformation from '@/components/pages/BankTransferInformation.vue';
import PaygeTransferInformation from '@/components/pages/PaygeTransferInformation.vue';
import PayRedirect from '@/components/pages/PayRedirect.vue';
import CompleteBuyPoint from '@/components/pages/CompleteBuyPoint.vue';
import CompleteBuyPointAmazonPay from '@/components/pages/CompleteBuyPointAmazonPay.vue';
import BuyProduct from '@/components/pages/BuyProduct.vue';
import ConfirmBuyProduct from '@/components/pages/ConfirmBuyProduct.vue';
import GachaAnimation from '@/components/pages/GachaAnimation.vue';
import GetCardList from '@/components/pages/GetCardList.vue';
// import ConfirmGetCardList from '@/components/pages/ConfirmGetCardList.vue';
// import ThankYou from '@/components/pages/ThankYou.vue';
// import MyPage from '@/components/pages/MyPage.vue';
import ChangePassword from '@/components/pages/ChangePassword.vue';
import BuyPointHistory from '@/components/pages/BuyPointHistory.vue';
// import BuyProductHistory from '@/components/pages/BuyProductHistory.vue';
// import BuyProductHistoryDetail from '@/components/pages/BuyProductHistoryDetail.vue';
import CoinHistory from '@/components/pages/CoinHistory.vue';
import SpecificCommerce from '@/components/pages/SpecificCommerce.vue';
import FundSettlement from '@/components/pages/FundSettlement.vue';
import PointTermsOfService from '@/components/pages/PointTermsOfService.vue';
import TermsOfService from '@/components/pages/TermsOfService.vue';
import PrivacyProtection from '@/components/pages/PrivacyProtection.vue';
import UserGuide from '@/components/pages/UserGuide.vue';
import UserAddress from '@/components/pages/UserAddress.vue';
import CardInput from '@/components/pages/CardInput.vue';
import UserMenu from '@/components/pages/UserMenu.vue';
import ChangeMember from '@/components/pages/ChangeMember.vue';
// import TransferPoint from '@/components/pages/TransferPoint.vue';
// import ExchangeCard from '@/components/pages/ExchangeCard.vue';
import CompleteBuyPointPayPal from '@/components/pages/CompleteBuyPointPayPal.vue';
import CompleteCarrier from '@/components/pages/CompleteCarrier.vue';
import ContactList from '@/components/pages/ContactList.vue';
import WatchVideos from '@/components/pages/WatchVideos.vue';
import NoticeList from '@/components/pages/NoticeList.vue';
import Copied from '@/components/pages/Copied.vue';
import FAQ from '@/components/pages/FAQ.vue';
import BuyPurchaseHistory from '@/components/pages/BuyPurchaseHistory.vue';
import BuyPurchaseHistoryDetail from '@/components/pages/BuyPurchaseHistoryDetail.vue';
import PurchaseCard from '@/components/pages/PurchaseCard.vue';
import PendingDetail from '@/components/pages/PendingDetail.vue';
import ShippedDetail from '@/components/pages/ShippedDetail.vue';
import UndecidedDetail from '@/components/pages/UndecidedDetail.vue';
import DownloadedDetail from '@/components/pages/DownloadedDetail.vue';
import Market from '@/components/pages/Market/Market.vue';
import MarketMyListUndecided from '@/components/pages/Market/MarketMyListUndecided.vue';
import MarketMyListSoldout from '@/components/pages/Market/MarketMyListSoldout.vue';
import MarketMyListDisplay from '@/components/pages/Market/MarketMyListDisplay.vue';
import BuyMarketHistory from '@/components/pages/Market/BuyMarketHistory.vue';
import RequestPayment from '@/components/pages/Market/RequestPayment.vue';
import BuyMarketHistoryDetail from '@/components/pages/Market/BuyMarketHistoryDetail.vue';
import MarketBuyProduct from '@/components/pages/Market/MarketBuyProduct.vue';
import CompleteBuyMarket from '@/components/pages/Market/CompleteBuyMarket.vue';
import StoreCorporation from '@/components/pages/StoreCorporation.vue';
import StoreCorporationDetail from '@/components/pages/StoreCorporationDetail.vue';
import OAuthLogin from '@/components/pages/OAuthLogin.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/', name: 'Top', component: Top, meta: { requiresLogin: false },
  },
  {
    path: '/store', name: 'Store', component: Store, meta: { requiresLogin: false },
  },
  {
    path: '/store-corporation', name: 'StoreCorporation', component: StoreCorporation, meta: { requiresLogin: false },
  },
  {
    path: '/store/page/:url', name: 'StoreCorporationDetail', component: StoreCorporationDetail, meta: { requiresLogin: false },
  },
  {
    path: '/store-gacha', name: 'StoreGachaLineup', component: StoreGachaLineup, meta: { requiresLogin: false },
  },
  {
    path: '/store-pack-detail', name: 'StorePackDetail', component: StorePackDetail, meta: { requiresLogin: false },
  },
  {
    path: '/copied', name: 'Copied', component: Copied, meta: { requiresLogin: false },
  },
  {
    path: '/faq', name: 'FAQ', component: FAQ, meta: { requiresLogin: false },
  },
  {
    path: '/pack-list', name: 'PackList', component: PackList, meta: { requiresLogin: false },
  },
  {
    path: '/pack-detail', name: 'PackDetail', component: PackDetail, meta: { requiresLogin: false },
  },
  {
    path: '/Pending-detail', name: 'PendingDetail', component: PendingDetail, meta: { requiresLogin: false },
  },
  {
    path: '/undecided-detail', name: 'UndecidedDetail', component: UndecidedDetail, meta: { requiresLogin: false },
  },
  {
    path: '/Shipped-detail', name: 'ShippedDetail', component: ShippedDetail, meta: { requiresLogin: false },
  },
  {
    path: '/downloaded-detail', name: 'DownloadedDetail', component: DownloadedDetail, meta: { requiresLogin: false },
  },
  {
    path: '/market', name: 'Market', component: Market, meta: { requiresLogin: false },
  },
  {
    path: '/market-mylist-undecided', name: 'MarketMyListUndecided', component: MarketMyListUndecided, meta: { requiresLogin: false },
  },
  {
    path: '/market-mylist-display', name: 'MarketMyListDisplay', component: MarketMyListDisplay, meta: { requiresLogin: false },
  },
  {
    path: '/market-mylist-soldout', name: 'MarketMyListSoldout', component: MarketMyListSoldout, meta: { requiresLogin: false },
  },
  {
    path: '/market-buy-complete', name: 'CompleteBuyMarket', component: CompleteBuyMarket, meta: { requiresLogin: false },
  },
  {
    path: '/market-confirm-buy', name: 'MarketBuyProduct', component: MarketBuyProduct, meta: { requiresLogin: false },
  },
  {
    path: '/market-history', name: 'BuyMarketHistory', component: BuyMarketHistory, meta: { requiresLogin: false },
  },
  {
    path: '/market-history-detail', name: 'BuyMarketHistoryDetail', component: BuyMarketHistoryDetail, meta: { requiresLogin: false },
  },
  {
    path: '/request-payment', name: 'RequestPayment', component: RequestPayment, meta: { requiresLogin: false },
  },
  // {
  //   path: '/login', name: 'UserLogin', component: UserLogin, meta: { requiresLogin: false },
  // },
  {
    path: '/password-reissue', name: 'PasswordReissue', component: PasswordReissue, meta: { requiresLogin: false },
  },
  {
    path: '/onetime-password-reissue', name: 'OnetimePasswordReissue', component: OnetimePasswordReissue, meta: { requiresLogin: false },
  },
  {
    path: '/complete-password-reissue', name: 'CompletePasswordReissue', component: CompletePasswordReissue, meta: { requiresLogin: false },
  },
  // {
  //   path: '/user-register', name: 'UserRegister', component: UserRegister, meta: { requiresLogin: false },
  // },
  {
    path: '/user-address', name: 'UserAddress', component: UserAddress, meta: { requiresLogin: false },
  },
  // {
  //   path: '/confirm-user-register', name: 'ConfirmUserRegister', component: ConfirmUserRegister, meta: { requiresLogin: false },
  // },
  {
    path: '/confirm-user-address', name: 'ConfirmUserAddress', component: ConfirmUserAddress, meta: { requiresLogin: false },
  },
  {
    path: '/complete-user-register', name: 'CompleteUserRegister', component: CompleteUserRegister, meta: { requiresLogin: false },
  },
  {
    path: '/buy-point', name: 'BuyPoint', component: BuyPoint, meta: { requiresLogin: true },
  },
  {
    path: '/confirm-buy-point', name: 'ConfirmBuyPoint', component: ConfirmBuyPoint, meta: { requiresLogin: true },
  },
  {
    path: '/confirm-combini', name: 'ConfirmCombini', component: ConfirmCombini, meta: { requiresLogin: true },
  },
  {
    path: '/bank-transfer-information', name: 'BankTransferInformation', component: BankTransferInformation, meta: { requiresLogin: true },
  },
  {
    path: '/payge-transfer-information', name: 'PaygeTransferInformation', component: PaygeTransferInformation, meta: { requiresLogin: true },
  },
  {
    path: '/user-guide', name: 'UserGuide', component: UserGuide, meta: { requiresLogin: false },
  },
  {
    path: '/complete-carrier', name: 'CompleteCarrier', component: CompleteCarrier, meta: { requiresLogin: false },
  },
  {
    path: '/error-carrier', name: 'CompleteCarrier', component: CompleteCarrier, meta: { requiresLogin: false },
  },
  {
    // MEMO: イプシロンからのリダイレクト先空ページ
    path: '/pay-redirect',
    name: 'PayRedirect',
    component: PayRedirect,
    meta: { requiresLogin: true },
    beforeEnter: (to, from, next) => {
      const postParams = {
        token: to.query.payment_id,
      };
      store.dispatch('user/pointAppend', { postParams });
      next({ path: '/complete-buy-point', query: to.query });
    },
  },
  {
    path: '/complete-buy-point', name: 'CompleteBuyPoint', component: CompleteBuyPoint, meta: { requiresLogin: true },
  },
  {
    // MEMO: AmazonPayからのリダイレクト先空ページ
    path: '/amazon-pay-redirect',
    name: 'AmazonPayRedirect',
    component: PayRedirect,
    meta: { requiresLogin: true },
    beforeEnter: (to, from, next) => {
      fetch('/api/user/complete_checkout_session')
        .then((res) => res.json())
        .then((data) => {
          // マーケット購入の場合は market-buy-complete へ遷移
          if (data && data.type === 'market') {
            next({ path: '/market-buy-complete', query: to.query });
          } else {
            // コイン購入の場合は従来通り
            next({ path: '/complete-buy-point-amazom-pay', query: to.query });
          }
        });
    },
  },
  {
    path: '/complete-buy-point-amazom-pay', name: 'CompleteBuyPointAmazonPay', component: CompleteBuyPointAmazonPay, meta: { requiresLogin: true },
  },
  {
    path: '/complete-buy-point-paypal', name: 'CompleteBuyPointPayPal', component: CompleteBuyPointPayPal, meta: { requiresLogin: true },
  },
  {
    path: '/buy-product', name: 'BuyProduct', component: BuyProduct, meta: { requiresLogin: true },
  },
  {
    path: '/confirm-buy-product', name: 'ConfirmBuyProduct', component: ConfirmBuyProduct, meta: { requiresLogin: true },
  },
  {
    path: '/gacha-animation',
    name: 'GachaAnimation',
    component: GachaAnimation,
    meta: { requiresLogin: true },
    beforeEnter: (to, from, next) => {
      (async () => {
        await store.dispatch('pack/setGachaResult');
        const buyPackResult = store.getters['pack/buyPackResult'];
        const isRedirectTop = buyPackResult.cards.length === 0;
        if (isRedirectTop) {
          next('/');
        } else if (from.name === 'ConfirmBuyProduct' || from.name === 'PackDetail' || from.name === 'Top' || from.name === 'Store' || from.name === 'StorePackDetail' || from.name === 'StoreCorporationDetail') {
          const isFromShop = from.name === 'Store' || from.name === 'StorePackDetail' || from.name === 'StoreCorporationDetail';
          store.commit('pack/setIsFromShop', isFromShop);
          next();
        } else {
          next('/get-card-list');
        }
      })();
    },
  },
  {
    path: '/get-card-list',
    name: 'GetCardList',
    component: GetCardList,
    meta: { requiresLogin: true },
    beforeEnter: (to, from, next) => {
      (async () => {
        await store.dispatch('pack/setBuyPackResult');
        const buyPackResult = store.getters['pack/buyPackResult'];
        const isRedirectTop = buyPackResult.cards.length === 0;
        if (isRedirectTop) {
          next('/');
        } else {
          next();
        }
      })();
    },
  },
  // {
  //   path: '/confirm-get-card-list',
  //   name: 'ConfirmGetCardList',
  //   component: ConfirmGetCardList,
  //   meta: { requiresLogin: true },
  //   beforeEnter: (to, from, next) => {
  //     (async () => {
  //       await store.dispatch('pack/setBuyPackResult');
  //       const buyPackResult = store.getters['pack/buyPackResult'];
  //       const isRedirectTop = buyPackResult.cards.length === 0;
  //       if (isRedirectTop) {
  //         next('/');
  //       } else {
  //         next();
  //       }
  //     })();
  //   },
  // },
  // {
  //   path: '/thank-you', name: 'ThankYou', component: ThankYou, meta: { requiresLogin: true },
  // },
  // {
  //   path: '/my-page', name: 'MyPage', component: MyPage, meta: { requiresLogin: true },
  // },
  {
    path: '/change-password', name: 'ChangePassword', component: ChangePassword, meta: { requiresLogin: true },
  },
  {
    path: '/buy-point-history', name: 'BuyPointHistory', component: BuyPointHistory, meta: { requiresLogin: true },
  },
  // {
  //   path: '/buy-product-history', name: 'BuyProductHistory', component: BuyProductHistory, meta: { requiresLogin: true },
  // },
  // {
  //   path: '/buy-product-history-detail', name: 'BuyProductHistoryDetail', component: BuyProductHistoryDetail, meta: { requiresLogin: true },
  // },
  {
    path: '/coin-history', name: 'CoinHistory', component: CoinHistory, meta: { requiresLogin: true },
  },
  {
    path: '/specific-commerce', name: 'SpecificCommerce', component: SpecificCommerce, meta: { requiresLogin: false },
  },
  {
    path: '/fund-settlement', name: 'FundSettlement', component: FundSettlement, meta: { requiresLogin: false },
  },
  {
    path: '/gem-terms-of-service', name: 'PointTermsOfService', component: PointTermsOfService, meta: { requiresLogin: false },
  },
  {
    path: '/terms-of-service', name: 'TermsOfService', component: TermsOfService, meta: { requiresLogin: false },
  },
  {
    path: '/privacy-protection', name: 'PrivacyProtection', component: PrivacyProtection, meta: { requiresLogin: false },
  },
  {
    path: '/user-menu', name: 'UserMenu', component: UserMenu, meta: { requiresLogin: true },
  },
  {
    path: '/change-member', name: 'ChangeMember', component: ChangeMember, meta: { requiresLogin: true },
  },
  {
    path: '/purchase-card', name: 'PurchaseCard', component: PurchaseCard, meta: { requiresLogin: false },
  },
  {
    path: '/purchase-history', name: 'BuyPurchaseHistory', component: BuyPurchaseHistory, meta: { requiresLogin: true },
  },
  {
    path: '/purchase-history-detail', name: 'BuyPurchaseHistoryDetail', component: BuyPurchaseHistoryDetail, meta: { requiresLogin: true },
  },
  // {
  //   path: '/transfer-point', name: 'TransferPoint', component: TransferPoint, meta: { requiresLogin: true },
  // },
  // {
  //   path: '/exchange-card', name: 'ExchangeCard', component: ExchangeCard, meta: { requiresLogin: true },
  // },
  {
    path: '/notice-list', name: 'NoticeList', component: NoticeList, meta: { requiresLogin: true },
  },
  {
    path: '/contact', name: 'ContactList', component: ContactList, meta: { requiresLogin: true },
  },
  {
    path: '/watch-videos', name: 'WatchVideos', component: WatchVideos, meta: { requiresLogin: true },
  },
  {
    path: '/oauth/login',
    name: 'OAuthLogin',
    component: OAuthLogin,
    meta: { requiresLogin: false },
  },
  {
    path: '*',
    name: 'NotFound',
    beforeEnter: (to, from, next) => {
      next('/');
    },
  },
  {
    path: '/card-input', name: 'CardInput', component: CardInput, meta: { requiresLogin: true },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  store.dispatch('setFullPath', to.fullPath);
  if (to.matched.some((record) => record.meta.requiresLogin)) {
    (async () => {
      try {
        await store.dispatch('user/setCurrentUser');
        const storeDataUser = store.getters['user/currentUser'];
        const csrfToken = storeDataUser.csrf;
        store.dispatch('setCsrf', { csrfToken });
        const isLogin = storeDataUser.is_login;
        if (isLogin === '1') {
          next();
        } else {
          next('/');
          this.$store.dispatch('user/setShowLoginPage', true);
        }
      } catch (error) {
        next('/');
        this.$store.dispatch('user/setShowLoginPage', true);
      }
    })();
  } else {
    (async () => {
      try {
        await store.dispatch('user/setCurrentUser');
        const storeDataUser = store.getters['user/currentUser'];
        const csrfToken = storeDataUser.csrf;
        store.dispatch('setCsrf', { csrfToken });
        next();
      } catch (error) {
        next();
      }
    })();
  }
  setTimeout(() => {
    window.scrollTo(0, 1); // 縦方向に少しスクロール
  }, 100);
});

// Market MyList以外のページに遷移した際にstoreをクリア
router.afterEach((to) => {
  const currentPath = to.path;
  if (!currentPath.includes('market-mylist')) {
    store.dispatch('market/clearMyListCardType');
  }
});

export default router;
